import Alpine from 'alpinejs';

window.Alpine = Alpine;

// Safari 11 polyfill for AlpineJS, see also https://github.com/alpinejs/alpine/discussions/1964
if (typeof window.queueMicrotask !== 'function') {
    window.queueMicrotask = function (callback) {
        Promise.resolve()
            .then(callback)
            .catch((e) =>
                setTimeout(() => {
                    throw e;
                })
            );
    };
}

// Per-component Alpine modules sit next to the Fusion file they hydrate.
// DownloadsPage.alpine.js lives as a sibling of Presentation/Template/
// DownloadsPage.fusion; InteractiveMapWithAccordion.alpine.js under
// Presentation/Component/InteractiveMapWithAccordion/.
import './Presentation/Template/DownloadsPage.alpine';
import './Presentation/Component/InteractiveMapWithAccordion/InteractiveMapWithAccordion.alpine';
import './Integration/Organism/FilteredReferenceList/FilteredReferenceList.alpine';
import '../../../NodeTypes/Content/ReferencesMap/ReferencesMap.alpine';

Alpine.start();
